module.exports = __webpack_public_path__ + "static/media/new-jersey.8eff6af7.jpg";